//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props: ['categories', 'button_text', 'portfolio_link'],
    data() {
        return {
            index: 0,
            numberOfEntries: this.categories.length,
            interval: setInterval(() => this.increaseIndex(), 5000),
            isScrolled: false
        };
    },
    methods: {
        increaseIndex() {
            if(this.index >= this.numberOfEntries - 1) {
                this.index = 0;
            } else {
                this.index++;
            }
            clearInterval(this.interval);
            this.interval = setInterval(() => this.increaseIndex(), 5000);
        },
        decreaseIndex() {
            if(this.index <= 0) {
                this.index = this.numberOfEntries - 1;
            } else {
                this.index--;
            }
            clearInterval(this.interval);
            this.interval = setInterval(() => this.increaseIndex(), 5000);
        },
        prepareSwitcherNumber(number) { number++; return number >= 10 ? number : '0' + number; }
    },
    mounted() {
        let slider = $('.home-slider');
        // Swipe
        slider.hammer().on('swipeleft', () => this.increaseIndex());
        slider.hammer().on('swiperight', () => this.decreaseIndex());
        // Scroll
        $('.home-slider__entry').on('mousewheel', event => {
            if(!this.isScrolled) {
                this.isScrolled = true;
                if(event.originalEvent.wheelDelta / 120 > 0) {
                    this.decreaseIndex();
                } else {
                    this.increaseIndex();
                }
                setTimeout(() => { this.isScrolled = false; }, 1000);
            }
        });
    }
}



// WEBPACK FOOTER //
// ./scripts/vue/home-slider.vue